import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
//import Backend from 'i18next-xhr-backend';
import { initReactI18next } from "react-i18next";
import translationEN from "./i18n/en.json";
import translationFR from "./i18n/fr.json";
import translationAR from "./i18n/ar.json";

// the translations
const resources = {
  en: {
    front: translationEN,
  },
  fr: {
    front: translationFR,
  },
  ar: {
    front: translationAR,
  },
};
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: ["front"],
    defaultNS: "front",
    resources,
    fallbackLng: "en",
    debug: false,
    detection: {
      order: ["localStorage", "cookie", "nav", "htmlTag", "path", "subdomain"],
      caches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

// Set initial attributes
document.documentElement.setAttribute("lang", i18n.language);
document.documentElement.setAttribute(
  "dir",
  i18n.language === "ar" ? "rtl" : "ltr"
);

i18n.on("languageChanged", (lng) => {
  const oldDir = document.documentElement.getAttribute("dir");
  const newDir = lng === "ar" ? "rtl" : "ltr";

  if (oldDir !== newDir) {
    document.body.classList.add("switching-direction");

    setTimeout(() => {
      document.documentElement.setAttribute("lang", lng);
      document.documentElement.setAttribute("dir", newDir);

      // Allow one reflow before removing class to trigger animation
      setTimeout(() => {
        document.body.classList.remove("switching-direction");
      }, 50);
    }, 300); // Wait for fade out
  } else {
    document.documentElement.setAttribute("lang", lng);
  }
});

export default i18n;
